import { Button, dialog } from "nq-component";

const DeleteModal = (confirm) => {
  return dialog.fire({
    html: (
      <div>
        <div className="row p-3">
          <div
            className="col-md-12"
            style={{ width: "100%", margin: "0 auto" }}
          >
            <h5 className="m-0 ms-2 mt-2">Delete Confirmation</h5>
            <hr />
          </div>
          <h5 className="text-center m-0" style={{ padding: "1rem" }}>
            Are you sure you want to delete this data?
          </h5>
          <div
            className="col-md-12"
            style={{ width: "100%", margin: "0 auto" }}
          >
            <hr />
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end gap-2 pe-3 pb-3">
          <Button
            className="btn btn-light fs-sm"
            onClick={() => {
              dialog.close();
            }}
          >
            Close
          </Button>
          <Button className="btn btn-primary fs-sm" onClick={confirm}>
            <i
              className="bi bi-trash"
              style={{ color: "white", fontSize: "17px" }}
            ></i>
            &nbsp;Delete
          </Button>
        </div>
      </div>
    ),
    footer: false,
  });
};

export default DeleteModal;
